import { Alert, Avatar, Button, Card, Checkbox, Col, DatePicker, Form, List, Modal, Radio, Row, Select, Table, Space, Typography, Descriptions, Tooltip, Image, message, Tag, Progress } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { UserOutlined, UnorderedListOutlined, SwapOutlined, DownloadOutlined, ReloadOutlined, CalendarOutlined, TeamOutlined, ClockCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import dayjs from 'dayjs';
import { exportSummary } from './export/exportSummary';
import { exportAttendanceDetail } from './export/exportAttendanceDetail';
import { exportOvertime } from './export/exportOvertime';
import { useI18n } from '../../Utils/i18n';
const { Text } = Typography;

function Attendance() {
    const [form] = Form.useForm();
    const { translate } = useI18n();
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [type, setType] = useState([]);
    const [position, setPosition] = useState([]);
    const [positionValue, setPositionValue] = useState('');
    const [employee, setEmployee] = useState([]);
    const [area, setArea] = useState([]);
    const [location, setLocation] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [showSelectType, setShowSelectType] = useState('all');
    const [typeExport, setTypeExport] = useState('attendance');
    const [checkedAll, setCheckedAll] = useState(true);

    const [total_absent, set_total_absent] = useState(0);
    const [total_check_in, set_total_check_in] = useState(0);
    const [total_check_out, set_total_check_out] = useState(0);
    const [total_no_check_in, set_total_no_check_in] = useState(0);
    const [total_no_check_out, set_total_no_check_out] = useState(0);
    const [on_time, set_on_time] = useState(0);
    const [total_late, set_total_late] = useState(0);

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [dateSelected, setDateSelected] = useState('');

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [exportStartDate, setExportStartDate] = useState(null);
    const [exportEndDate, setExportEndDate] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState([]);

    const [pageEmployee, setPageEmployee] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [currentStatusKey, setCurrentStatusKey] = useState("");
    const [isModalDetail, setIsModalDetail] = useState(null);
    const [dataModal, setDataModal] = useState(null);
    const [shifts, setShifts] = useState([]);
    const [employeeStatuses, setEmployeeStatuses] = useState([]);
    const [isChangeShiftModalVisible, setIsChangeShiftModalVisible] = useState(false);
    const [changeShiftUser, setChangeShiftUser] = useState(null);
    const [changeShiftId, setChangeShiftId] = useState(null);
    const [exportUserOnly, setExportUserOnly] = useState(false);
    const [exportProgress, setExportProgress] = useState({ percent: 0, text: '' });
    const [exportLoading, setExportLoading] = useState(false);

    const titlePage = translate('Attendance Data');
    const columns = [
        {
            title: translate('No'),
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: translate('User Code'),
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => record.users_code
        },
        {
            title: translate('Name'),
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.name || '-'
        },
        {
            title: translate('Schedule'),
            dataIndex: 'schedule',
            key: "schedule",
            render: (text, record) => {
                const info = getScheduleInfo(record);
                return info.name || "-";
            }
        },
        {
            title: translate('Time In'),
            dataIndex: 'time_in',
            key: "time_in",
            render: (text, record) => {
                const info = getScheduleInfo(record);
                return info.timeIn || "-";
            }
        },
        {
            title: translate('Time Out'),
            dataIndex: 'time_out',
            key: "time_out",
            render: (text, record) => {
                const info = getScheduleInfo(record);
                return info.timeOut || "-";
            }
        },
        {
            title: translate('Clock In'),
            dataIndex: 'clockin',
            key: "clockin",
            render: (text, record) => {
                if (record.attendance.length > 0) {
                    const { timeIn } = getTimeInAndOut(record.attendance);
                    return timeIn || "-";
                }
                return "-";
            }
        },
        {
            title: translate('Clock Out'),
            dataIndex: 'clockout',
            key: "clockout",
            render: (text, record) => {
                if (record.attendance.length > 0) {
                    const { timeOut } = getTimeInAndOut(record.attendance);
                    return timeOut || "-";
                }
                return "-";
            }
        },
        {
            title: translate('Overtime'),
            dataIndex: 'overtime',
            key: "overtime",
            render: (text, record) => {
                if (record.overtime.length > 0) {
                    const { overtimeTime } = getOvertimeRest(record.overtime);
                    return overtimeTime || "-";
                }
                return "-";
            }
        },
        {
            title: translate('Overtime Break'),
            dataIndex: 'break',
            key: "break",
            render: (text, record) => {
                if (record.overtime.length > 0) {
                    const { restTime } = getOvertimeRest(record.overtime);
                    return restTime || "-";
                }
                return "-";
            }
        },
        {
            title: translate('Action'),
            dataIndex: 'action',
            key: "action",
            render: (text, record) => {
                return (
                    <>
                        <Tooltip title="Detail">
                            <Button type="default" style={{ marginRight: 10 }} onClick={() => {
                                setDataModal(record);
                                setIsModalDetail(true);
                            }}>
                                <UnorderedListOutlined />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Ganti Shift">
                            <Button type="default" style={{ marginRight: 10 }} onClick={() => openChangeShift(record)}>
                                <SwapOutlined />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Export Rekap Absensi">
                            <Button type="default" onClick={() => openUserExport(record)}>
                                <DownloadOutlined />
                            </Button>
                        </Tooltip>
                    </>
                );
            }
        },
    ];

    // Attendance memakai tanggal kalender (bukan timestamp). Hindari `new Date('YYYY-MM-DD')`
    // karena string tersebut diperlakukan sebagai UTC oleh browser dan bisa bergeser tanggal
    // ketika dikonversi ke timezone lokal.
    const normalizeAttendanceDate = (value) => {
        if (!value) return '';

        if (dayjs.isDayjs(value)) {
            return value.isValid() ? value.format('YYYY-MM-DD') : '';
        }

        if (moment.isMoment(value)) {
            return value.isValid() ? value.format('YYYY-MM-DD') : '';
        }

        if (typeof value === 'string') {
            const calendarDate = value.match(/^(\d{4}-\d{2}-\d{2})/);
            if (calendarDate) return calendarDate[1];

            const parsedString = moment(value, ['DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD'], true);
            return parsedString.isValid() ? parsedString.format('YYYY-MM-DD') : '';
        }

        const parsed = moment(value);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
    };

    const formatAttendanceDate = (value) => {
        const normalized = normalizeAttendanceDate(value);
        return normalized ? moment(normalized, 'YYYY-MM-DD', true).format('DD/MM/YYYY') : '-';
    };

    const getShiftDay = (record, targetDate = dateSelected) => {
        if (!record?.schedule?.shift_day) return null;

        const normalizedDate = normalizeAttendanceDate(targetDate);
        if (!normalizedDate) return null;

        const dayName = moment(normalizedDate, 'YYYY-MM-DD', true).format('dddd');

        return record.schedule.shift_day.find(
            d => String(d?.day_name || '').trim().toLowerCase() === dayName.toLowerCase()
        ) || null;
    };

    // Urutan sumber jadwal Attendance:
    // 1. user_shift khusus tanggal, 2. schedule mingguan, 3. shift langsung user.
    // Kolom Schedule menampilkan NAMA SCHEDULE bila user memakai schedule, bukan
    // nama shift hariannya. Untuk data lama yang schedule-nya tidak memiliki
    // shift_day lengkap, coba cocokkan schedule_name dengan master shift agar
    // Time In/Out tetap tampil (contoh: Office 6).
    const getScheduleInfo = (record) => {
        const normalizedDate = normalizeAttendanceDate(dateSelected);

        const datedUserShift = (record?.user_shift || []).find((us) => {
            const userShiftDate = normalizeAttendanceDate(us?.date);
            return normalizedDate && userShiftDate === normalizedDate;
        });

        if (datedUserShift?.shift) {
            return {
                name: datedUserShift.shift.name || '-',
                timeIn: datedUserShift.shift.time_in || '-',
                timeOut: datedUserShift.shift.time_out || '-',
            };
        }

        const shiftDay = getShiftDay(record, normalizedDate);
        if (record?.schedule) {
            const scheduleName = record.schedule.schedule_name || shiftDay?.shift?.name || '-';

            if (shiftDay?.shift) {
                return {
                    name: scheduleName,
                    timeIn: shiftDay.shift.time_in || '-',
                    timeOut: shiftDay.shift.time_out || '-',
                };
            }

            const sameNameShift = (shifts || []).find(
                (shift) => String(shift?.name || '').trim().toLowerCase() === String(scheduleName || '').trim().toLowerCase()
            );

            return {
                name: scheduleName,
                timeIn: sameNameShift?.time_in || record?.shift?.time_in || '-',
                timeOut: sameNameShift?.time_out || record?.shift?.time_out || '-',
            };
        }

        if (record?.shift) {
            return {
                name: record.shift.name || '-',
                timeIn: record.shift.time_in || '-',
                timeOut: record.shift.time_out || '-',
            };
        }

        return { name: '-', timeIn: '-', timeOut: '-' };
    };

    useEffect(() => {
        setSelectedEmployee([]);
        setSelectedArea([]);
        setSelectedLocation([]);
    }, [showSelectType]);

    useEffect(() => {
        const dates = normalizeAttendanceDate(dateSelected) || moment().format('YYYY-MM-DD');
        if (dateSelected === '') {
            setDateSelected(dates);
            return;
        }
        if (type.length === 0) getApi("GET", '/leavetype?nopage=true', 'type');
        if (employee.length === 0) getApi("GET", '/selectusers?nopage=true', 'employee');
        if (area.length === 0) getApi("GET", '/area?nopage=true', 'area');
        if (location.length === 0) getApi("GET", '/attendancelocation?nopage=true', 'location');
        if (position.length === 0) getApi("GET", '/position?nopage=true', 'position');
        if (shifts.length === 0) getApi("GET", '/shift?nopage=true', 'shift');
        if (employeeStatuses.length === 0) getApi("GET", '/employee-status?nopage=true', 'employee_status');

        getApi("GET", '/totalattendanceadmin?date=' + dates, 'total_attendance');
        getApi(
            "GET",
            '/attendanceadmin?date=' + dates +
            '&positionId=' + (positionValue || '') +
            '&search=' + encodeURIComponent(search || '') +
            '&page=' + page.pagination.current +
            '&limit=' + page.pagination.pageSize,
            'attendance'
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateSelected, positionValue, search, page.pagination.current, page.pagination.pageSize, isAlert]);

    function attendanceSortValue(att) {
        const date = String(att?.date || '').slice(0, 10);
        const time = String(att?.time || '').slice(0, 8);
        const dateTime = `${date} ${time}`.trim();

        if (date && time) return dateTime;
        if (att?.created_at) return String(att.created_at);
        return '';
    }

    function compareAttendanceAsc(a, b) {
        const aValue = attendanceSortValue(a);
        const bValue = attendanceSortValue(b);

        if (aValue !== bValue) return aValue.localeCompare(bValue);
        return Number(a?.attendance_id || 0) - Number(b?.attendance_id || 0);
    }

    function getTimeInAndOut(attendance = []) {
        // Clock In harus selalu mengambil check-in PALING PERTAMA,
        // tidak bergantung pada urutan array yang dikirim backend.
        const firstCheckIn = attendance
            .filter((att) => att?.status === 'checkin')
            .slice()
            .sort(compareAttendanceAsc)[0];

        // Perilaku Clock Out dipertahankan seperti sebelumnya: record checkout
        // pertama dari response.
        const firstCheckOut = attendance.find((att) => att?.status === 'checkout');

        return {
            timeIn: firstCheckIn?.time || null,
            timeOut: firstCheckOut?.time || null,
        };
    }

    function getEmployeeStatusLabel(record) {
        const rawStatus = record?.employee_status;

        // Backend terbaru sudah mengirim nama status. Kalau masih angka,
        // frontend fallback lookup lewat employee_status_id / master status.
        if (rawStatus !== null && rawStatus !== undefined && rawStatus !== '' && !/^\d+$/.test(String(rawStatus).trim())) {
            return rawStatus;
        }

        const statusId = record?.employee_status_id || rawStatus;
        const status = employeeStatuses.find(
            (item) => String(item.employee_status_id) === String(statusId)
        );

        return status?.name || '-';
    }

    function getGradeLabel(grade) {
        const value = String(grade ?? '').trim();
        if (!value) return '-';
        if (/^grade\s+/i.test(value)) return value;
        if (/^\d+$/.test(value)) return `Grade ${value}`;
        return value;
    }

    function getOvertimeRest(overtime) {
        let totalOvertimeSeconds = 0;
        let totalRestSeconds = 0;

        if (overtime.length > 0) {
            overtime.forEach(att => {
                var over1 = parseTime(att.before_shift_overtime_duration);
                var over2 = parseTime(att.after_shift_overtime_duration);

                // Konversi waktu istirahat ke detik
                var rest1 = parseTime(att.after_shift_rest_duration);
                var rest2 = parseTime(att.before_shift_rest_duration);

                // Jumlahkan waktu overtime dan istirahat
                totalOvertimeSeconds += (over1 + over2);
                totalRestSeconds += (rest1 + rest2);
            });
        }

        // Konversi total waktu overtime dan istirahat kembali ke format hh:mm:ss
        return { overtimeTime: formatTime(totalOvertimeSeconds), restTime: formatTime(totalRestSeconds) };
    }

    // Fungsi untuk mengkonversi waktu dalam format "hh:mm:ss" menjadi detik
    function parseTime(time) {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return (hours * 3600) + (minutes * 60) + seconds;
    }

    // Fungsi untuk mengkonversi total detik kembali ke format "hh:mm:ss"
    function formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const sec = seconds % 60;
        return `${padZero(hours)}:${padZero(minutes)}:${padZero(sec)}`;
    }

    // Fungsi untuk menambahkan angka nol di depan jika dibutuhkan
    function padZero(number) {
        return number < 10 ? '0' + number : number;
    }

    const getApi = (method, url, type) => {
        setLoading(true);

        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'type':
                        setType(res.data.data);
                        setLoading(false);
                        break;
                    case 'position':
                        var row = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            row.push({
                                value: res.data.data[i].position_id,
                                label: res.data.data[i].name,
                            });
                        }
                        setPosition(row);
                        setLoading(false);
                        break;
                    case 'employee':
                        setEmployee(res.data.data);
                        setLoading(false);
                        break;
                    case 'area':
                        setArea(res.data.data);
                        setLoading(false);
                        break;
                    case 'location':
                        setLocation(res.data.data);
                        setLoading(false);
                        break;
                    case 'shift':
                        setShifts(res.data.data);
                        setLoading(false);
                        break;
                    case 'employee_status':
                        setEmployeeStatuses(res.data.data || []);
                        setLoading(false);
                        break;
                    case 'attendance':
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data
                            }
                        });
                        setLoading(false);
                        break;
                    case 'total_attendance':
                        set_total_absent(res.data.absent);
                        set_total_check_in(res.data.check_in);
                        set_total_check_out(res.data.check_out);
                        set_total_late(res.data.late);
                        set_total_no_check_in(res.data.no_checkin);
                        set_total_no_check_out(res.data.no_clockout);
                        set_on_time(res.data.on_time);
                        setLoading(false);
                        break;

                    default:
                        setLoading(false);
                        break;
                }
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }


    const resetFilters = () => {
        setPositionValue('');
        setSearch('');
        setDateSelected(moment().format('YYYY-MM-DD'));
        setPage({ pagination: { current: 1, pageSize: 10 } });
    };

    const onChangeDate = (date, dateString) => {
        // Ant Design v5 DatePicker memakai dayjs. Gunakan dateString sebagai nilai kalender
        // agar tidak terjadi konflik moment/dayjs yang bisa membuat panel kalender lompat tahun.
        const selectedDate = normalizeAttendanceDate(dateString) || normalizeAttendanceDate(date);
        if (!selectedDate) return;

        setDateSelected(selectedDate);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        // getApi("GET", '/totalattendanceadmin?date=' + dateString, 'total_attendance');
        // getApi("GET", '/attendanceadmin?date=' + dateString + '&search=' + search + '&page=' + page.pagination.current + '&limit=' + page.pagination.pageSize, 'attendance');
    };

    const openUserExport = (record) => {
        // Tutup modal detail lebih dulu supaya popup DatePicker tidak tertutup overlay modal lain.
        setIsModalDetail(false);
        setExportUserOnly(true);
        setShowSelectType('employee');
        setSelectedEmployee([record.users_id]);
        setSelectedArea([]);
        setSelectedLocation([]);
        setSelectedStatus([
            'all',
            'present',
            'no_clock_out',
            'late',
            'alpha',
            ...type.map(e => e.leave_type_id),
        ]);
        setCheckedAll(true);
        setTypeExport('summary');
        setExportStartDate(null);
        setExportEndDate(null);
        setIsExportModalVisible(true);
    };

    const openChangeShift = (record) => {
        const currentShift = record.user_shift?.[0]?.shift || getShiftDay(record)?.shift;

        // Hindari dua modal aktif bersamaan karena dropdown Select dapat berada di bawah overlay modal detail.
        setIsModalDetail(false);
        setChangeShiftUser(record);
        setChangeShiftId(currentShift?.shift_id != null ? Number(currentShift.shift_id) : undefined);
        setIsChangeShiftModalVisible(true);
    };

    const handleChangeShift = async () => {
        if (!changeShiftUser?.users_id || !changeShiftId || !dateSelected) {
            message.error('User, tanggal, dan shift wajib dipilih');
            return;
        }

        setLoading(true);
        try {
            const res = await apiCall({
                method: 'PUT',
                url: '/usershift/change',
                data: {
                    data: {
                        users_id: changeShiftUser.users_id,
                        shift_id: changeShiftId,
                        date: dateSelected,
                    },
                    headers: { Authorization: 'Bearer ' + token }
                }
            });

            if (res.status === 'success') {
                message.success(res.message || 'Shift berhasil diganti');
                setIsChangeShiftModalVisible(false);
                setIsAlert(true);
                setTextAlert(res.message || 'Shift berhasil diganti');
            } else {
                message.error(res.message || 'Gagal mengganti shift');
            }
        } catch (error) {
            console.error(error);
            message.error('Gagal mengganti shift');
        } finally {
            setLoading(false);
        }
    };

    const handleExport = async () => {
        setExportProgress({ percent: 2, text: 'Menyiapkan export…' });

        if (!exportStartDate || !exportEndDate) {
            modalError("Start date is required!");
            setExportProgress({ percent: 0, text: '' });
            return;
        }

        setIsExportModalVisible(false);
        setExportLoading(true);

        try {
            const startDate = moment(exportStartDate).format('YYYY-MM-DD');
            const endDate = moment(exportEndDate).format('YYYY-MM-DD');

            const buildUrl = (chunkStart, chunkEnd) => {
                let url = `/attendanceadmin?nopage=true&export=true&exportType=${typeExport}&dateStart=${chunkStart}&dateEnd=${chunkEnd}&status=${selectedStatus}`;
                if (showSelectType === 'employee') {
                    url += `&employees=${selectedEmployee}`;
                } else if (showSelectType === 'area') {
                    url += `&area=${selectedArea}`;
                } else if (showSelectType === 'location') {
                    url += `&location=${selectedLocation}`;
                }
                return url;
            };

            // Split long exports per calendar month. A one-year export becomes ~12 smaller
            // requests so it does not hang on one very large response and progress is real.
            const chunks = [];
            let cursor = moment(startDate).startOf('day');
            const rangeEnd = moment(endDate).endOf('day');
            while (cursor.isSameOrBefore(rangeEnd, 'day')) {
                const chunkEnd = moment.min(cursor.clone().endOf('month'), rangeEnd);
                chunks.push({
                    start: cursor.format('YYYY-MM-DD'),
                    end: chunkEnd.format('YYYY-MM-DD'),
                });
                cursor = chunkEnd.clone().add(1, 'day').startOf('day');
            }

            setExportProgress({ percent: 5, text: 'Memeriksa kalender dan hari libur…' });
            const holidayRes = await apiCall({
                method: 'GET',
                url: `/holiday?startDate=${startDate}&endDate=${endDate}&limit=500`,
                data: { headers: { Authorization: 'Bearer ' + token } }
            });

            let holiday = [];
            if (holidayRes.status === 'success') holiday = holidayRes.data;

            const attendanceByUser = new Map();
            const mergeRows = (target, source, field, idKey) => {
                const current = Array.isArray(target[field]) ? target[field] : [];
                const incoming = Array.isArray(source[field]) ? source[field] : [];
                const seen = new Set(current.map((row) => row?.[idKey]).filter((v) => v != null));
                incoming.forEach((row) => {
                    const key = row?.[idKey];
                    if (key == null || !seen.has(key)) {
                        current.push(row);
                        if (key != null) seen.add(key);
                    }
                });
                target[field] = current;
            };
            for (let i = 0; i < chunks.length; i += 1) {
                const chunk = chunks[i];
                const requestPercent = 8 + Math.round(((i + 1) / chunks.length) * 77);
                setExportProgress({
                    percent: requestPercent,
                    text: `Mengambil absensi bulan ${i + 1} dari ${chunks.length} • ${chunk.start} s/d ${chunk.end}…`,
                });

                const res = await apiCall({
                    method: 'GET',
                    url: buildUrl(chunk.start, chunk.end),
                    data: { headers: { Authorization: 'Bearer ' + token } }
                });

                if (res.status !== 'success') {
                    throw new Error(res.message || `Gagal mengambil data periode ${chunk.start} - ${chunk.end}`);
                }
                const rows = res?.data?.data || [];
                rows.forEach((row) => {
                    const key = row.users_id;
                    if (!attendanceByUser.has(key)) {
                        attendanceByUser.set(key, { ...row });
                        return;
                    }
                    const merged = attendanceByUser.get(key);
                    mergeRows(merged, row, 'attendance', 'attendance_id');
                    mergeRows(merged, row, 'overtime', 'overtime_id');
                    mergeRows(merged, row, 'user_shift', 'user_shift_id');
                    mergeRows(merged, row, 'leave_paid', 'leave_paid_id');
                });
            }

            setExportProgress({ percent: 88, text: 'Menggabungkan data dari seluruh periode…' });
            await new Promise((resolve) => window.requestAnimationFrame(() => resolve()));
            const attendanceData = Array.from(attendanceByUser.values());
            setExportProgress({ percent: 94, text: `Membuat file Excel dari ${attendanceData.length} karyawan…` });
            // Give React one frame to paint progress before the synchronous Excel generation starts.
            await new Promise((resolve) => window.requestAnimationFrame(() => resolve()));

            if (typeExport === "summary") {
                exportSummary(attendanceData, exportStartDate, exportEndDate, selectedStatus, holiday);
            } else if (typeExport === "detail") {
                exportAttendanceDetail(attendanceData, startDate, endDate, selectedStatus, holiday);
            } else if (typeExport === "overtime") {
                exportOvertime(attendanceData, startDate, endDate, holiday);
            }

            setExportProgress({ percent: 100, text: 'Export selesai. File sedang diunduh…' });
            message.success(`Export selesai: ${attendanceData.length} data berhasil diproses`);
            setExportUserOnly(false);
            await new Promise((resolve) => window.setTimeout(resolve, 650));
        } catch (error) {
            console.error(error);
            modalError(error?.message || "Failed to export data");
        } finally {
            setExportLoading(false);
            window.setTimeout(() => setExportProgress({ percent: 0, text: '' }), 300);
        }
    };

    const onCheckStatus = (value) => {
        if (value.includes("all")) {
            const allValues = ["all", "present", "no_clock_out", "late", "alpha", ...type.map(e => e.leave_type_id)];
            setCheckedAll(true);
            setSelectedStatus(allValues);
        } else {
            if (checkedAll === true) {
                setSelectedStatus([]);
                setCheckedAll(false);
            } else if (value.length === 0) {
                setSelectedStatus([]);
            } else {
                const newValue = value.filter(val => val !== "all");
                setSelectedStatus(newValue);
            }
        }
    }

    const showPopup = async (title, filterKey) => {
        try {
            setModalTitle(title);
            setFilteredEmployees([]);
            setPageEmployee(1);
            setCurrentStatusKey(filterKey);
            setHasMore(true);
            setIsModalVisible(true);
            loadMoreDataEmployee(filterKey, 1, true);
        } catch (error) {
            console.error("Error initializing popup:", error);
        }
    };

    const loadMoreDataEmployee = async (status, pageToLoad, isInitial = false) => {
        if (loading || !hasMore) return;

        setLoading(true);

        try {
            const res = await apiCall({
                method: 'GET',
                url: `/attendanceadmin/status?status=${status}&date=${dateSelected}&page=${pageToLoad}&limit=10`,
                data: {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            });

            if (res.status === "success" && res.data.data) {
                const newData = res.data.data;
                setFilteredEmployees(prev => isInitial ? newData : [...prev, ...newData]);

                if (newData.length < 10) {
                    setHasMore(false);
                } else {
                    setPageEmployee(pageToLoad + 1);
                }
            }
        } catch (error) {
            console.error("Error fetching more data:", error);
        } finally {
            setLoading(false);
        }
    };

    const attendanceColumns = [
        {
            title: 'Tanggal',
            dataIndex: 'date',
            key: 'date',
            render: (text) => formatAttendanceDate(text),
        },
        {
            title: 'Waktu',
            dataIndex: 'time',
            key: 'time',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => record.status === 'checkin' ? 'Clock In' : 'Clock Out',
        },
        {
            title: 'Keterangan',
            dataIndex: 'desc',
            key: 'desc',
        },
        {
            title: 'Foto',
            dataIndex: 'image',
            key: 'image',
            render: (src) => <Image width={80} src={src} />,
        },
    ];

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <div style={{ marginBottom: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 24, lineHeight: 1.3 }}>{translate('Attendance Data')}</h2>
                        <div style={{ color: '#8c8c8c', marginTop: 4 }}>{translate('Monitor employee attendance, shifts, lateness, and attendance recaps.')}</div>
                    </div>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={() => {
                            setExportUserOnly(false);
                            setShowSelectType('all');
                            setSelectedEmployee([]);
                            setIsExportModalVisible(true);
                        }}
                    >
                        {translate('Export Data')}
                    </Button>
                </div>
            </div>

            <Card bodyStyle={{ padding: 16 }} style={{ marginBottom: 16, borderRadius: 10 }}>
                <div style={{ fontWeight: 600, marginBottom: 12 }}>{translate('Attendance Filter')}</div>
                <Row gutter={[12, 12]} align="bottom">
                    <Col xs={24} sm={12} md={6}>
                        <div style={{ color: 'var(--app-text-muted)', fontSize: 12, marginBottom: 6 }}>Tanggal</div>
                        <DatePicker
                            value={dateSelected ? dayjs(dateSelected, 'YYYY-MM-DD') : null}
                            onChange={onChangeDate}
                            format="YYYY-MM-DD"
                            placeholder="Pilih tanggal"
                            allowClear={false}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <div style={{ color: 'var(--app-text-muted)', fontSize: 12, marginBottom: 6 }}>{translate('Position')}</div>
                        <select
                            className="app-native-control"
                            value={positionValue || ''}
                            onChange={(e) => {
                                setPositionValue(e.target.value);
                                setPage({ pagination: { current: 1, pageSize: page.pagination.pageSize } });
                            }}
                            style={{
                                width: '100%', height: 40, border: '1px solid #d9d9d9', borderRadius: 10,
                                padding: '0 12px', outline: 'none', cursor: 'pointer',
                                fontSize: 14, lineHeight: '40px'
                            }}
                        >
                            <option value="">{translate('All Positions')}</option>
                            {position.map((item) => (
                                <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </Col>
                    <Col xs={24} sm={16} md={8}>
                        <div style={{ color: 'var(--app-text-muted)', fontSize: 12, marginBottom: 6 }}>{translate('Search Employee')}</div>
                        <Search
                            placeholder={translate('Name or user code')}
                            allowClear
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onSearch={searchData}
                            enterButton={translate('Search')}
                        />
                    </Col>
                    <Col xs={24} sm={8} md={4}>
                        <Button icon={<ReloadOutlined />} onClick={resetFilters} style={{ width: '100%' }}>{translate('Reset Filter')}</Button>
                    </Col>
                </Row>
                <div style={{ marginTop: 12, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ color: 'var(--app-text-muted)', fontSize: 12 }}>{translate('Active filters:')}</span>
                    <Tag icon={<CalendarOutlined />}>{dateSelected || '-'}</Tag>
                    {positionValue && <Tag icon={<TeamOutlined />}>{position.find(p => String(p.value) === String(positionValue))?.label || 'Position'}</Tag>}
                    {search && <Tag>Search: {search}</Tag>}
                </div>
            </Card>

            <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("Clock In", "checkin")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <ClockCircleOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_check_in}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('Clock In')}</div>
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("Clock Out", "checkout")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <ClockCircleOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_check_out}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('Clock Out')}</div>
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("Terlambat", "late")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <WarningOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_late}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('Late')}</div>
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("Absen", "absent")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <TeamOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_absent}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('Absent')}</div>
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("No Clock In", "no_check_in")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <WarningOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_no_check_in}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('No Clock In')}</div>
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={4}>
                    <Card hoverable onClick={() => showPopup("No Clock Out", "no_check_out")} bodyStyle={{ padding: 14 }} style={{ borderRadius: 10 }}>
                        <WarningOutlined style={{ fontSize: 18 }} />
                        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>{total_no_check_out}</div>
                        <div style={{ color: '#8c8c8c' }}>{translate('No Clock Out')}</div>
                    </Card>
                </Col>
            </Row>

            <Card bodyStyle={{ padding: 0 }} style={{ borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ padding: '14px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <div style={{ fontWeight: 600 }}>{translate('Attendance List')}</div>
                        <div style={{ color: 'var(--app-text-muted)', fontSize: 12 }}>{page.pagination.total || 0} data ditemukan</div>
                    </div>
                </div>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.users_id}
                pagination={{ ...page.pagination, showSizeChanger: true, showTotal: (total) => `Total ${total} data` }}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: 1250 }}
            />
            </Card>
            <Modal
                width={440}
                centered
                visible={exportLoading}
                closable={false}
                maskClosable={false}
                keyboard={false}
                footer={null}
                title={translate('Export Progress')}
                className="attendance-export-progress-modal"
            >
                <div style={{ padding: '8px 2px 4px' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: 12 }}>
                        <Text strong style={{ fontSize: 16 }}>{translate('Processing export')}</Text>
                        <Text strong style={{ fontSize: 20 }}>{exportProgress.percent || 0}%</Text>
                    </div>
                    <Progress
                        percent={exportProgress.percent || 0}
                        status={exportProgress.percent >= 100 ? 'success' : 'active'}
                        strokeWidth={12}
                        showInfo={false}
                    />
                    <div style={{ marginTop: 14, padding: '12px 14px', borderRadius: 10, background: 'rgba(0,0,0,.035)' }}>
                        <Text>{exportProgress.text || translate('Preparing export…')}</Text>
                    </div>
                    <Text type="secondary" style={{ display: 'block', marginTop: 10, fontSize: 12 }}>
                        Jangan tutup halaman sampai proses export selesai.
                    </Text>
                </div>
            </Modal>

            <Modal
                width={650}
                title={exportUserOnly ? translate('Export Attendance Recap') : translate('Export Data')}
                visible={isExportModalVisible}
                onOk={handleExport}
                onCancel={() => { setIsExportModalVisible(false); setExportUserOnly(false); }}
                footer={[
                    <Button key="cancel" onClick={() => { setIsExportModalVisible(false); setExportUserOnly(false); }}>
                        Cancel
                    </Button>,
                    <Button key="export-status" disabled={exportLoading} type="primary" onClick={() => handleExport()}>
                        Export Excel
                    </Button>,
                ]}
            >
                <Form layout="vertical" form={form}>
                    <Form.Item label={translate('Date Period')}>
                        <Row gutter={12}>
                            <Col xs={24} sm={12}>
                                <label style={{ display: 'block', marginBottom: 6 }}>{translate('From Date')}</label>
                                <input
                                    className="app-native-control"
                                    type="date"
                                    value={exportStartDate || ''}
                                    max={exportEndDate || undefined}
                                    onChange={(e) => setExportStartDate(e.target.value)}
                                    style={{
                                        width: '100%',
                                        height: 32,
                                        padding: '4px 11px',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: 8,
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12}>
                                <label style={{ display: 'block', marginBottom: 6 }}>{translate('Until Date')}</label>
                                <input
                                    className="app-native-control"
                                    type="date"
                                    value={exportEndDate || ''}
                                    min={exportStartDate || undefined}
                                    onChange={(e) => setExportEndDate(e.target.value)}
                                    style={{
                                        width: '100%',
                                        height: 32,
                                        padding: '4px 11px',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: 8,
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </Col>
                        </Row>
                    </Form.Item>

                    {!exportUserOnly && (
                        <>
                            <Form.Item label={translate('Choose Type')}>
                                <Radio.Group onChange={e => setShowSelectType(e.target.value)} value={showSelectType}>
                                    <Radio value="all">All Employee </Radio>
                                    <Radio value="employee">Choose Employee</Radio>
                                    <Radio value="area">Choose Area/Branch</Radio>
                                    <Radio value="location">Choose Location</Radio>
                                </Radio.Group>

                                {showSelectType === "employee" && (
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        placeholder="Choose Employee"
                                        value={selectedEmployee}
                                        onChange={value => setSelectedEmployee(value)}
                                        style={{ width: '100%', marginTop: '10px' }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                                        }
                                    >
                                        {employee.map(e => (
                                            <Select.Option key={e.users_id} value={e.users_id}>
                                                {e.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}

                                {showSelectType === "area" && (
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        placeholder="Choose Area"
                                        value={selectedArea}
                                        onChange={value => setSelectedArea(value)}
                                        style={{ width: '100%', marginTop: '10px' }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                                        }
                                    >
                                        {area.map(e => (
                                            <Select.Option key={e.area_id} value={e.area_id}>
                                                {e.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}

                                {showSelectType === "location" && (
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        placeholder="Choose Location"
                                        value={selectedLocation}
                                        onChange={value => setSelectedLocation(value)}
                                        style={{ width: '100%', marginTop: '10px' }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                                        }
                                    >
                                        {location.map(e => (
                                            <Select.Option key={e.attendance_location_id} value={e.attendance_location_id}>
                                                {e.name_set}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={translate('Choose Status')}>
                                <Checkbox.Group
                                    value={selectedStatus}
                                    onChange={value => onCheckStatus(value)}
                                    style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}
                                >
                                    <Checkbox value="all">All Status</Checkbox>
                                    <Checkbox value="present">Present</Checkbox>
                                    <Checkbox value="no_clock_out">Tidak Clock Out</Checkbox>
                                    <Checkbox value="late">Late</Checkbox>
                                    <Checkbox value="alpha">Alpha</Checkbox>
                                    {type.map(e => (
                                        <Checkbox key={e.leave_type_id} value={e.leave_type_id}>
                                            {e.name}
                                        </Checkbox>
                                    ))}
                                </Checkbox.Group>
                            </Form.Item>
                        </>
                    )}
                    <Form.Item label={<Text strong style={{ fontSize: 16 }}>Choose Data Type</Text>}>
                        <Radio.Group
                            onChange={e => setTypeExport(e.target.value)}
                            value={typeExport}
                            buttonStyle="solid"
                            size="middle"
                        >
                            <Space direction="vertical" size="middle">
                                {/* <Radio.Button value="attendance" style={{ width: 250, textAlign: 'center' }}>
                                    Employee Absence
                                </Radio.Button>
                                <Radio.Button value="total_status" style={{ width: 250, textAlign: 'center' }}>
                                    Total Employee Absence
                                </Radio.Button> */}
                                <Radio.Button value="summary" style={{ width: 250, textAlign: 'center' }}>
                                    Absence Summary
                                </Radio.Button>
                                <Radio.Button value="detail" style={{ width: 250, textAlign: 'center' }}>
                                    Absence Details Summary
                                </Radio.Button>
                                <Radio.Button value="overtime" style={{ width: 250, textAlign: 'center' }}>
                                    Employee Overtime
                                </Radio.Button>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title={modalTitle}
                visible={isModalVisible}
                onCancel={() => {
                    setIsModalVisible(false);
                    setFilteredEmployees([]);
                    setPageEmployee(1);
                    setHasMore(true);
                }}
                footer={null}
            >
                <div
                    style={{ maxHeight: '60vh', overflowY: 'auto' }}
                    onScroll={(e) => {
                        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                        if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && !loading) {
                            loadMoreDataEmployee(currentStatusKey, pageEmployee);
                        }
                    }}
                >
                    <List
                        itemLayout="horizontal"
                        dataSource={filteredEmployees}
                        renderItem={employee => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={
                                        <Avatar
                                            src={employee.image || undefined}
                                            alt={`${employee.name}'s avatar`}
                                            icon={!employee.image ? <UserOutlined /> : undefined}
                                        />
                                    }
                                    title={<span style={{ fontWeight: 'bold' }}>{employee.name}</span>}
                                    description={<span style={{ color: 'gray' }}>{employee.position.name}</span>}
                                />
                            </List.Item>
                        )}
                    />
                    {loading && <div style={{ textAlign: 'center', padding: 10 }}>Loading...</div>}
                </div>
            </Modal>

            <Modal
                title="Ganti Shift"
                visible={isChangeShiftModalVisible}
                onOk={handleChangeShift}
                onCancel={() => setIsChangeShiftModalVisible(false)}
                confirmLoading={loading}
                okText="Simpan Shift"
            >
                <Form layout="vertical">
                    <Form.Item label="Karyawan">
                        <strong>{changeShiftUser?.name || '-'}</strong>
                    </Form.Item>
                    <Form.Item label="Tanggal">
                        <strong>{dateSelected || '-'}</strong>
                    </Form.Item>
                    <Form.Item label="Shift" required>
                        <select
                            value={changeShiftId ?? ''}
                            onChange={(e) => setChangeShiftId(e.target.value ? Number(e.target.value) : undefined)}
                            style={{
                                width: '100%',
                                height: 36,
                                padding: '4px 11px',
                                border: '1px solid #d9d9d9',
                                borderRadius: 2,
                                background: '#fff',
                                boxSizing: 'border-box',
                                cursor: 'pointer',
                            }}
                        >
                            <option value="">Pilih shift</option>
                            {shifts.map((shift) => (
                                <option key={shift.shift_id} value={Number(shift.shift_id)}>
                                    {shift.name} ({shift.time_in} - {shift.time_out})
                                </option>
                            ))}
                        </select>
                        {shifts.length === 0 && (
                            <div style={{ marginTop: 6, color: '#ff4d4f' }}>Data shift tidak tersedia.</div>
                        )}
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Detail User"
                visible={isModalDetail}
                onCancel={() => setIsModalDetail(false)}
                footer={null}
                width={800}
            >
                {
                    dataModal !== null &&
                    <Descriptions title="Informasi Pengguna" bordered column={2}>
                        <Descriptions.Item label="Nama">{dataModal.name}</Descriptions.Item>
                        <Descriptions.Item label="Posisi">{dataModal.position?.name}</Descriptions.Item>
                        <Descriptions.Item label="Divisi">{dataModal.division?.name}</Descriptions.Item>
                        <Descriptions.Item label="Status Pegawai">{getEmployeeStatusLabel(dataModal)}</Descriptions.Item>
                        <Descriptions.Item label="Grade">{getGradeLabel(dataModal.grade)}</Descriptions.Item>
                        <Descriptions.Item label="Kelas">{dataModal.class}</Descriptions.Item>
                        <Descriptions.Item label="Tanggal Join">
                            {dataModal.join_date !== '' ? new Date(dataModal.join_date).toLocaleDateString() : '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Shift Saat Ini">
                            {dataModal.user_shift?.[0]?.shift?.name || getShiftDay(dataModal)?.shift?.name || '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Foto">
                            <Image width={100} src={dataModal.image} />
                        </Descriptions.Item>
                    </Descriptions>
                }

                {dataModal !== null && (
                    <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
                        <Button icon={<SwapOutlined />} onClick={() => openChangeShift(dataModal)}>
                            Ganti Shift
                        </Button>
                        <Button icon={<DownloadOutlined />} onClick={() => openUserExport(dataModal)}>
                            Export Rekap Absensi
                        </Button>
                    </div>
                )}

                {dataModal !== null && dataModal.attendance?.length > 0 && (
                    <>
                        <br />
                        <h3>Riwayat Kehadiran</h3>
                        <Table
                            columns={attendanceColumns}
                            dataSource={[...dataModal.attendance].sort(compareAttendanceAsc)}
                            rowKey="attendance_id"
                            pagination={false}
                            scroll={{ x: true }}
                        />
                    </>
                )}
            </Modal>
        </div>
    );
}


export default Attendance;